export const headers = {
  h1: {
    fontSize: "40px",
    lineHeight: "44px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0"
  },
  h2: {
    fontSize: "32px",
    lineHeight: "38px",
    fontWeight: "300",
    textTransform: "uppercase",
    letterSpacing: "-0.46px"
  },
  h3: {
    fontSize: "25px",
    lineHeight: "32px",
    fontWeight: "600",
    textTransform: "none",
    letterSpacing: "0"
  },
  h4: {
    fontSize: "17px",
    lineHeight: "24px",
    fontWeight: "400",
    textTransform: "none",
    letterSpacing: "0"
  }
};